module.exports = __webpack_public_path__ + "static/diagram2-66c00a543e2141e7d88b66082be6311f.jpg";